import { render } from "./BurgerComponent.vue?vue&type=template&id=39256c2e"
import script from "./BurgerComponent.vue?vue&type=script&lang=js"
export * from "./BurgerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__